export class ConnectAtlasOrganizationRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "apiPublicKey",
            "baseName": "apiPublicKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "apiPrivateKey",
            "baseName": "apiPrivateKey",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectAtlasOrganizationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
